/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 11:00:38
 */
export default {
  lang: "ru",
  landing: {
    name1: "Открыть Carlcare",
    name2: "Забронировать",
    name3: "Carlcare позволяет проверять состояние заказа в любое время.",
    name4: "",
    name5: "Сдвиньте вправо",
    name6: "Проверка завершена",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "Выберите модель устройства",
    name2: "Описание неисправности:",
    name3: "Нажмите для выбора сервисного центра",
    name4: "Сервисный центр:",
    name5: "Время бронирования:",
    name6: "Подробно опишите проблему с вашим устройством",
    name7: "Нажмите для выбора времени посещения",
    name8: "Укажите свои контактные данные, чтобы мы могли связаться с вами",
    name9: "Доступное для бронирования время:",
    name10: "Пожалуйста, введите номер вашего телефона",
    name11: "Цена",
    name12: "Личная информация:",
    name13: "Пожалуйста, введите ваше имя",
    name14: "Подтвердить",
    name15: "Отменить",
    name16: "ОК",
  },
  shops: {
    name1: "Обслуживание вашей модели телефона возможно в следующих магазинах:",
    name2: "Скоро и в других розничных магазинах. Оставайтесь с нами!",
  },
  price: {
    name1: "Бренд",
    name2: "Модель",
    name3: "ТОВАР",
    name4: "Цена",
    name5: "Напоминание:",
    name6: "Информация о ценах носит справочный характер. Фактическая цена зависит от состояния вашего устройства.",
    name7: "Если символ валюты отсутствует, цена приведена в местной валюте.",
    name8: "Извините! Для текущего региона информация о ценах недоступна.",
    name11:"Трудозатраты",
    name12:"Итоговая цена",
    name13: "5. Если стоимость трудовых затрат равна \"/\", это означает, что ее необходимо уточнить в магазине.",
    item_main_board: "Материнская плата",
    item_screen_frame: "Экран (с рамкой)",
    item_screen_screen_frame: "Вторичный экран (с рамкой)",
    item_touch_screen: "Сенсорный экран",
    item_camera: "Камера",
    item_fixed_focus_camera: "Камера с фиксированным фокусом",
    item_auto_focus_camera: "Камера с автофокусом",
    item_screen: "Экран",
    item_secondary_screen: "Вторичный экран",
    item_fingerprint_module: "Модуль отпечатков пальцев",
    item_speaker: "Динамик",
    item_receiver: "Получатель",
    item_small_board: "Компактная плата",
    item_battery_cover: "Крышка аккумулятора",
    item_battery: "Аккумулятор",
    item_charger: "Зарядное устройство",
    item_usb_cable: "USB-кабель",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Данные отсутствуют",
    name2: "Оператор:",
    name3: "Бренд:",
    name4: "Телефон:",
    name5: "Оценка заказа:",
    name6: "Оценка обслуживания",
    name7: "Условия обслуживания:",
    name8: "Отношение персонала:",
    name9: "Эффективность:",
    name10: "Качество обслуживания:",
    name11: "Оценка клиента",
    name12:"к",
    name13:"Выключено",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Открыть Carlcare",
    name1: "Сделайте скриншот с данными резервирования и сохраните его - он служит талоном на доступ к приоритетному обслуживанию.",
    name2: "Отправлено",
    name3: "1. Удалите данные.",
    name4: "Заблаговременно создайте резервную копию данных вашего устройства и выполните сброс до заводских настроек.",
    name5: "2. Отключите пароль экрана блокировки.",
    name6: "Перед посещением сервисного центра:",
    // name3: "1. Удалите данные",
    // name4: "Предварительно создайте копию важных личных данных, хранящихся в вашем телефоне",
    // name5: "2. Отключите ввод пароля при включении телефона",
    // name6: "Перед посещением сервис-центра:",
    name7: "Сервисный центр:",
    name8: "Время бронирования:",
    name9: "Описание неисправности:",
    name10: "Модель устройства:",
    name11: "Номер заказа：",
    name12: "Информация о заказе",
  },
  title: {
    name1: "Поддерживаемые страны:",
    name2: "Выберите модель",
    name3: "Резервирование",
    name4: "Подробная информация о сервисном центре",
    name5: "Выберите сервисный центр",
  },
  error: {
    name1: "Нет данных. Прочтите информацию о ремонте",
    name2: "Нужна помощь? Свяжитесь с нами.",
    name3: "К сожалению, в текущем регионе сервис-центра Carlcare нет.",
    name4: "Сначала выберите сервис-центр",
    name5: "Сбой",
    name6: "Сначала выберите модель устройства",
    name7: "Сведения",
    name8: "Подробно опишите ваши потребности",
    name9: "",
  },
  add1:{
    "name0": "ru",
    "name1": "Ваш заказ подтвержден. С нетерпением ждем вас.",
    "name2": "Выбрать город",
    "name3": "Введите номер телефона, содержащий %1$s цифр.",
    "name4": "Часы в рабочие дни",
    "name5": "Понедельник",
    "name6": "Вторник",
    "name7": "Среда",
    "name8": "Четверг",
    "name9": "Пятница",
    "name10": "Суббота",
    "name11": "Воскресенье",
    "name12": "Введите страну и выполните поиск"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Другие",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Нажмите, чтобы перейти",
    name3:"Откройте приложение Carlcare для оценки сервисного обслуживания",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Выберите сервис",
    name7:"Бесплатная очистка",
    name8:"Обновление ПО",
  },
  runame1:'Все',//all
  runame2:"Поиск",//search
  runame3:"Сервисный центр и время бронирования:",//Service Store & reservation Time:
  runame4:"Нажмите для выбора сервисного центра и времени бронирования",//all
  runame5:"Рекомендуем",//Recommend
  runame6:"Подробнее",//Detail
  runame7:"Пожалуйста, опишите подробно проблему с вашим устройством",//维修详情描述
  runame8:"999099",//all
  runame9:"999099",//all
  runame10:"999099",//all
  cancelorder:{
    "cancelReason0": "Неверная информация",
    "cancelReason1": "Невозможно прибыть вовремя",
    "cancelReason2": "Дублирующийся заказ/не мой заказ",
    "cancelReason3": "Неисправность не воспроизводится",
    "cancelReason4": "Только для теста/запроса/события/…",
    "cancelReason5": "Высокая цена",
    "cancelReason6": "Нет запчастей",
    "cancelReason7": "Нет дифференцированных услуг",
    "cancelReason8": "Сервисный центр слишком далеко",
    "cancelReason9": "Сервисный центр закрыт",
    "cancelReason10": "Низкое качество обслуживания",
    "cancelReason11": "Замена/ремонт продукции других производителей",
    "cancelReason12": "Не удалось найти сервисный центр",
    "cancelReason13": "Другое",
    "cancelOrder": "Отменить заказ",
    "reason_dialog_title": "Укажите причину отмены",
    "Cancel": "Отменить",
    "OK": "ОК",
    "name1": "Ввести код подтверждения",
    "name2": "Неверный код подтверждения",
    "repair_reservation_detail_canceled": "Этот заказ отменен!",
    "purchase_cancel_dialog_content": "Подтверждаете ли вы отмену заказа?",
    "yes": "Да",
    "no": "Нет"
}
};
